const actions = {
  setWindowStyle({ commit }, payload) {
    commit('setWindowStyle', payload);
  },
  setAwardRole({ commit }, payload) {
    commit('setAwardRole', payload);
  },
  setSubTabs({commit},payload){
    commit('setSubTabs', payload);
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js